import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SwipeableViews from "react-swipeable-views-react-18-fix";
import InfoIcon from "@mui/icons-material/Info";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import FilterVintageIcon from "@mui/icons-material/FilterVintage";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Card, CardActionArea, CardContent, CardMedia, Typography, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Rating from "@mui/material/Rating"; 

import Info from "./Pages/Info";
import Carte from "./Pages/Carte";
import Galerie from "./Pages/Galerie";
import Reservation from "./Pages/Reservation";

const options = [
  { id: 1, name: "Antinea", image: "/images/antinea.jpg", rating: 0 },
  { id: 2, name: "Republique", image: "/images/republique1.jpg", rating: 4 }, 
  { id: 3, name: "Vespucci", image: "/images/vespucci.jpg", rating: 3.5 }
];

const styles = {
  tabs: { background: "#fff" },
  slide: { padding: 15, minHeight: 100, color: "#fff" },
  slide1: { backgroundColor: "#FEA900" },
  slide2: { backgroundColor: "#B3DC4A" },
  slide3: { backgroundColor: "#6AC0FF" },
  slide4: { backgroundColor: "#B30000" },
};

const App = () => {
  const [showLanding, setShowLanding] = useState(true);
  const [index, setIndex] = useState(0);
  const [ratings, setRatings] = useState({});

  useEffect(() => {
    fetch("https://bbessere.lpmiaw.univ-lr.fr/resto/resto.php?getrating=true")
      .then(response => response.json())
      .then(data => {

        const firstRestaurantRating = parseFloat(data);
        

        setRatings(prevRatings => ({
          ...prevRatings,
          1: firstRestaurantRating,
        }));
      })
      .catch(error => console.error("Erreur lors de la récupération du rating :", error));
  }, []); 

  const handleNavigation = () => {
    setShowLanding(false);
  };

  const handleChange = (event, value) => {
    setIndex(value);
  };

  const handleChangeIndex = (index) => {
    setIndex(index);
  };

  return showLanding ? (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>Liste des restaurants de La Rochelle</h1>
      <p>Sélectionnez un restaurant dans la liste :</p>
      <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
        {options.map((option) => (
          <Card
            key={option.id}
            sx={{ maxWidth: 300, display: "flex", flexDirection: "column", cursor: "pointer" }}
            onClick={handleNavigation}
          >
            <CardActionArea>
              <CardMedia component="img" height="140" image={option.image} alt={option.name} />
              <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Typography variant="h6">{option.name}</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <Rating value={ratings[option.id] || option.rating} precision={0.5} readOnly />
                  <Typography variant="body2">{ratings[option.id] || option.rating} / 5</Typography>
                </Box>
                <ArrowForwardIcon />
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </div>
    </div>
  ) : (
    <div>
      <Tabs value={index} fullWidth centered onChange={handleChange} style={styles.tabs}>
        <Tab icon={<InfoIcon />} label="Info" />
        <Tab icon={<RestaurantIcon />} label="Carte" />
        <Tab icon={<FilterVintageIcon />} label="Galerie" />
        <Tab icon={<AccessTimeIcon />} label="Réservation" />
      </Tabs>
      <SwipeableViews index={index} onChangeIndex={handleChangeIndex} enableMouseEvents>
        <div style={{ ...styles.slide, ...styles.slide1 }}>
          <Info />
        </div>
        <div style={{ ...styles.slide, ...styles.slide2 }}>
          <Carte />
        </div>
        <div style={{ ...styles.slide, ...styles.slide3 }}>
          <Galerie />
        </div>
        <div style={{ ...styles.slide, ...styles.slide4 }}>
          <Reservation />
        </div>
      </SwipeableViews>
    </div>
  );
};

export default App;
